import React from "react";
import { IEmployeeId } from "../../Employee.props";
import EditEmployee from "./EditEmployee";



const EditEmployeeIndex: React.FC<IEmployeeId> = ({ employeeId ,setMethod}) => {

    return (
        <EditEmployee employeeId={employeeId} setMethod={setMethod}/>
    );
}

export default EditEmployeeIndex;
